import React, { Component } from "react";
import { View, TouchableWithoutFeedback, KeyboardAvoidingView, ScrollView, Platform } from "react-native";
import {appStyles, componentStyles} from "../theme/styles";


class BottomModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: props.show,
            waiting: props.waiting,
            visible: false
        }
        this.onClose = this.onClose.bind(this)
    }

    onClose() {

        this.setState({
            show: false,
        })
        this.props.onClose()


    }


    render() {
        return (this.state.show?<TouchableWithoutFeedback onPress={() => {
                    this.onClose()
                }}>


                <View style={appStyles.modalMessageAbsolute} >


                        <TouchableWithoutFeedback onPress={() => {

                        }}>
                            <KeyboardAvoidingView keyboardVerticalOffset={Platform.OS === 'ios' ? 0 : 30} behavior='padding'>
                                <View />

                                <View style={componentStyles.modalBottomContent}>
                                    <ScrollView keyboardShouldPersistTaps='handled' ref={ref => this.scrollView = ref}>
                                        {this.props.children}
                                    </ScrollView>
                                </View>

                                <View />
                            </KeyboardAvoidingView>
                        </TouchableWithoutFeedback>

                    </View>

                </TouchableWithoutFeedback>:<View/>
        );
    }
    componentWillReceiveProps(newprops) {
        this.setState({
            show: newprops.show,
            waiting: newprops.waiting
        })
        setTimeout(() => {
            this.setState({
                visible: newprops.show,
            })
        }, 50)
    }
}

export default BottomModal;
